export default "__VITE_ASSET__5NtTWZWO__"